import { render } from "./AdminEditForm.vue?vue&type=template&id=6425cc40&scoped=true"
import script from "./AdminEditForm.vue?vue&type=script&lang=js"
export * from "./AdminEditForm.vue?vue&type=script&lang=js"

import "./AdminEditForm.vue?vue&type=style&index=0&id=6425cc40&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6425cc40"]])

export default __exports__